import React,{useState,useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import EventListBody from './EventList/EventListBody'
import Button from '@material-ui/core/Button'
import AddBoxIcon from '@material-ui/icons/AddBox';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import {Link} from 'react-router-dom';
import EventSchedulerBody from './EventScheduler/EventSchedulerBody'
import NotFinishedPageWrapper from '../FunctionArea/NotFinishedPageWrapper'

  const useStyles = makeStyles(theme => ({
    
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
    },
    container: {
      padding: theme.spacing(1),
      //paddingTop: theme.spacing(4),
      //paddingBottom: theme.spacing(4),
    },
    paper: {
      //padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    fixedHeight: {
      height: 240,
    },
    createEventArea: {
      height:50,
      lineHeight:"50px"
    },
    textLink:{
      height:30,
      color:"white",
      fontFamily:"Microsoft JhengHei",
      borderStyle:"soild",
      borderWidth:1,
      borderColor:"black",
      backgroundColor:"#2783c4",
      textAlign:"center",
      fontSize:15,
      lineHeight:"30px",
      margin:5,
      '&:hover':{
       color:"black",
      }  
    }
   
  }));

  export default function EventManagementBody(props) {
    const classes = useStyles();
    const [showToken,setShowToken]= useState(false)

    useEffect(()=>{
      props.getCurrentModule("EventManagement")
    })


    const addZeroFirstAndToString = (num) =>{
      let output = ''
      if(num<10)
      {
        output = '0'+num
      }
      else
      {
        output = String(num)
      }
      return output
    }

    const getEventDate = () =>{
      let cDate = new Date()
      let tYear = addZeroFirstAndToString(cDate.getFullYear())
      let tMonth = addZeroFirstAndToString(cDate.getMonth()+1)
      let tDate = addZeroFirstAndToString(cDate.getDate())
      let tHour = addZeroFirstAndToString(cDate.getHours())
      let tMinute = addZeroFirstAndToString(cDate.getMinutes())
      return tYear+tMonth+tDate+tHour+tMinute
    }

    const getNewEventUrl = () =>{
      console.log('getNewEventUrl...')
      let tempID = getEventDate()
      console.log(tempID)
      return ('/EventManagement/EventEditMode/Create/Event_SysID/temp'+getEventDate()+props.userID)
    }

    return (
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          {showToken?<NotFinishedPageWrapper closeModal={()=>setShowToken(false)}/>:null}
          <Container maxWidth="xl" className={classes.container}>
            <Grid container spacing={1}>
              {/* Chart */}
              <Grid item xs={12} md={6} lg={6}>
                <Paper className={classes.fixedHeight}>
                  <Button className={classes.textLink} startIcon={<AddBoxIcon />} component={Link} to={getNewEventUrl}>
                    {'新增專題'}
                  </Button>   
                  <Button className={classes.textLink} startIcon={<FolderOpenIcon />} component={Link} onClick={()=>setShowToken(true)}>
                    {'開啟專題暫存檔'}
                  </Button>
                </Paper>
              </Grid>
              {/* Recent Deposits */}
              <Grid item xs={12} md={6} lg={6}>
                <Paper className={classes.fixedHeight}>
                  <EventSchedulerBody getSelectedEvent={(msg)=>{props.history.push("/EventManagement/EventEditMode/Edit/Event_SysID/"+msg)}}/>
                </Paper>
              </Grid>
              {/* Recent Orders */}
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  <EventListBody getSelectedEvent={(msg)=>{props.history.push("/EventManagement/EventEditMode/Edit/Event_SysID/"+msg)}}/>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </main>
    )
}